import React, { Suspense } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { LoadScript } from '@react-google-maps/api'
import { ToastContainer } from 'react-toastify'
import { GOOGLE_MAPS_API_KEY } from '@/constant/constant.ts'
import { useMapsConfig } from '@/hooks/useMapsConfig'
import { queryClient } from '@/api/queryClient.ts'
import FullPageLoading from '@/component/util/FullPageLoading'
import 'react-toastify/dist/ReactToastify.css'

interface AppProvidersProps {
    children: React.ReactNode
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
    const { region, language } = useMapsConfig()

    return (
        <Suspense fallback={<FullPageLoading />}>
            <LoadScript
                googleMapsApiKey={GOOGLE_MAPS_API_KEY}
                region={region}
                language={language}
                loadingElement={<FullPageLoading />}>
                <div className="font-sans">
                    <ToastContainer
                        position="bottom-right"
                        autoClose={3000}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss={false}
                        draggable
                        pauseOnHover
                        theme="light"
                        stacked
                    />
                    <QueryClientProvider client={queryClient}>
                        <BrowserRouter
                            future={{
                                v7_startTransition: true,
                                v7_relativeSplatPath: true
                            }}>
                            {children}
                        </BrowserRouter>
                    </QueryClientProvider>
                </div>
            </LoadScript>
        </Suspense>
    )
}
